/** @jsxImportSource @emotion/react */
import { useCallback } from 'react'
import BaseModal from 'src/components/ts-components/BaseModal'
import RichTextRenderer from '../RichTextRenderer'

type AdditionalInfoModalProps = {
  isOpen: boolean
  onClose: () => void
  content: string
  title?: string
}

const AdditionalInfoModal = ({
  isOpen,
  onClose,
  content,
  title = 'Additional Info',
}: AdditionalInfoModalProps) => {
  const handleClose = useCallback(() => {
    onClose()
  }, [onClose])

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
      cancelText='Close'
      desktopWidth='30vw'
    >
      <RichTextRenderer content={content} showReadMore={false} />
    </BaseModal>
  )
}

export default AdditionalInfoModal
